import {
  Button,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import theme from "../../../theme"
import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next';

const HeroSection = ({ presentation = {} }) => {
  const navigate = useNavigate()
  const { t } = useTranslation();
  const brandName = t('brand.name');
  const muiTheme = useTheme()
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"))
  const isSmallMobile = useMediaQuery(muiTheme.breakpoints.down("sm"))
  const layout = isMobile ? presentation.mobile || {} : presentation.desktop || {}
  const copyPrefix = presentation.copyKey
    ? `landing_hero.slides.${presentation.copyKey}`
    : "landing_hero"
  const ctaKey = presentation.ctaKey || "find_salon"

  const handleFindSalon = () => {
    window.sessionStorage.removeItem("glow.searchSalonState")
    navigate("/search-salon")
  }

  // Responsive styles
  const containerStyles = {
    margin: 0,
    padding: isSmallMobile ? "30px 56px 52px" : isMobile ? "36px 64px 60px" : "70px 7vw 92px",
    display: "flex",
    flexDirection: "column",
    alignItems: layout.alignItems || "center",
    textAlign: layout.textAlign || "center",
    minHeight: isMobile ? "calc(100vh - 56px)" : "calc(100vh - 64px)",
    justifyContent: "center",
    width: "100%",
    boxSizing: "border-box",
    position: "relative",
  }

  const titleStyles = {
    fontSize: layout.titleFontSize || (isMobile ? (isSmallMobile ? "2rem" : "2.5rem") : "3.5rem"),
    fontWeight: 700,
    color: layout.titleColor || presentation.titleColor || theme.colors.primary[800],
    margin: 0,
    marginBottom: layout.titleMarginBottom || (isMobile ? "20px" : "32px"),
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
    textShadow: layout.textShadow || presentation.textShadow || "0 2px 4px rgba(0,0,0,0.1)",
    maxWidth: "100%",
    transition: "color 0.45s ease, text-shadow 0.45s ease",
  }

  const subtitleStyles = {
    fontSize: layout.subtitleFontSize || (isMobile ? (isSmallMobile ? "1rem" : "1.1rem") : "1.25rem"),
    color: layout.subtitleColor || presentation.subtitleColor || theme.colors.text.secondary,
    margin: 0,
    marginBottom: layout.subtitleMarginBottom || (isMobile ? "40px" : "64px"),
    maxWidth: layout.subtitleMaxWidth || (isMobile ? "100%" : "680px"),
    fontWeight: layout.subtitleFontWeight || 400,
    opacity: 0.9,
    background: layout.subtitleBackground || "transparent",
    padding: layout.subtitlePadding || 0,
    borderRadius: layout.subtitleBorderRadius || 0,
    boxSizing: "border-box",
    lineHeight: layout.subtitleLineHeight || 1.6,
    textShadow: layout.textShadow || presentation.textShadow || "none",
    transition: "color 0.45s ease, text-shadow 0.45s ease",
  }

  const contentStyles = {
    width: "100%",
    maxWidth: layout.maxWidth || (isMobile ? "100%" : "900px"),
    display: "flex",
    flexDirection: "column",
    alignItems: layout.contentAlign || "center",
    textAlign: layout.textAlign || "center",
    position: layout.position || "relative",
    top: layout.top || "auto",
    right: layout.right || "auto",
    bottom: layout.bottom || "auto",
    left: layout.left || "auto",
    transform: `translate3d(${layout.translateX || "0px"}, ${layout.translateY || "0px"}, 0)`,
    transition: "transform 0.6s ease, max-width 0.6s ease",
  }

  return (
    <div id="heroSection" style={containerStyles}>
      <Box sx={contentStyles}>
        <h1 style={titleStyles}>{t(`${copyPrefix}.title`, { appName: brandName })}</h1>

        <p style={subtitleStyles}>
          {t(`${copyPrefix}.subtitle`)}
        </p>

        <Button
          onClick={handleFindSalon}
          sx={{
            backgroundColor: theme.colors.primary[600],
            color: "white",
            padding: layout.buttonPadding || (isMobile ? "16px 32px" : "20px 40px"),
            borderRadius: "50px",
            fontSize: layout.buttonFontSize || (isMobile ? "1.1rem" : "1.25rem"),
            fontWeight: 600,
            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: theme.colors.primary[700],
              transform: "translateY(-2px)",
              boxShadow: "0 6px 24px rgba(0,0,0,0.2)",
            },
          }}
        >
          {t(`landing_hero.${ctaKey}`)}
        </Button>
      </Box>
    </div>
  )
}

export default HeroSection
